import axios from 'axios';
import { Message } from 'element-ui'; // 使用 Element UI 的消息提示
import router from '@/router'; // 假设你有 Vue Router 配置

// 创建 Axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // API 的基础路径，从环境变量中获取（如果没有设置，默认为空）
  // baseURL: 'https://changyoucn.com/stbhq', // API 的基础路径，从环境变量中获取（如果没有设置，默认为空）
  timeout: 1000 * 60, // 请求超时时间（毫秒）
  headers: {
    'Content-Type': 'application/json;charset=UTF-8', // 默认请求头
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token'); // 获取本地存储中的 token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // 设置请求头 Authorization
    }

    // 如果接口路径以 /api/ 开头，需要去掉 baseURL 中的 /fyzx
    if (config.url && config.url.startsWith('/api/')) {
      const baseURL = config.baseURL || ''
      // 如果 baseURL 以 /stbhq 结尾，去掉它
      if (baseURL.endsWith('/fyzx')) {
        config.baseURL = baseURL.replace(/\/fyzx$/, '')
      }
    }

    // 打印请求路径，用于调试
    // console.log('Request URL:', config.baseURL + config.url);
    // 打印请求参数，用于调试
    // console.log('Request Params:', config.params);

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data;

    // 假设后端返回的数据结构为 { code, data, message }
    // 支持两种格式：code: 200 或 code: 0 表示成功
    const isSuccess = res.code === 200 || res.code === 0;
    
    if (!isSuccess) {
      // 根据业务逻辑处理错误
      const silentError = response && response.config && response.config.silentError
      if (!silentError) {
        Message.error(res.message || res.msg || '操作失败');
      }
      if (res.code === 401) {
        // Token 过期或未授权，跳转到登录页
        localStorage.removeItem('token');
        router.push('/login');
      }
      // 返回resolved的Promise，避免触发浏览器的错误遮罩
      // 调用方可以通过检查返回的code来判断请求是否成功
      return Promise.resolve(res);
    }

    // 返回实际数据部分，如果返回格式是 { code, data, message }，则返回 data
    // 如果返回格式是 { code, data, message }，直接返回 res 以便访问 data
    return res;
  },
  (error) => {
    // 对响应错误做点什么
    console.error('Response Error:', error);

    let errorMessage = '网络错误，请稍后再试！';
    if (error.response) {
      // 服务器返回了非 2xx 状态码
      // 优先使用响应体中的 msg 或 message
      const responseData = error.response.data;
      if (responseData && (responseData.msg || responseData.message)) {
        errorMessage = responseData.msg || responseData.message;
      } else {
        // 如果没有响应体中的错误信息，使用状态码对应的默认消息
        switch (error.response.status) {
          case 400:
            errorMessage = '请求参数错误';
            break;
          case 401:
            errorMessage = '未授权，请重新登录';
            localStorage.removeItem('token');
            router.push('/login');
            break;
          case 403:
            errorMessage = '拒绝访问';
            break;
          case 404:
            errorMessage = '资源不存在';
            break;
          case 500:
            errorMessage = '服务器内部错误';
            break;
          default:
            errorMessage = `连接错误 ${error.response.status}`;
        }
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      errorMessage = '服务器无响应';
    } else {
      // 其他错误
      errorMessage = error.message;
    }

    // 使用 Element UI 的 Message 组件显示错误提示
    Message.error(errorMessage);
    // 返回一个表示失败的resolved Promise，避免触发浏览器的错误遮罩
    // 调用方可以通过检查返回的code来判断请求是否成功
    return Promise.resolve({
      code: error.response ? error.response.status : -1,
      msg: errorMessage,
      message: errorMessage,
      data: null
    });
  }
);

/**
 * 封装 GET 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return service.get(url, { params });
}

/**
 * 封装 POST 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求体数据
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return service.post(url, data, config);
}

/**
 * 封装 PUT 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求体数据
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return service.put(url, data);
}

/**
 * 封装 PATCH 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求体数据
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return service.patch(url, data);
}

/**
 * 封装 DELETE 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function del(url, params = {}) {
  return service.delete(url, { params });
}

/**
 * 导出 Axios 实例
 */
export default service;
export const UPLOAD_BASE = 'https://changyoucn.com/api/file/upload';
